import * as React from "react";
import { useAppSelector } from "../store/index";
import { RootState } from "../reducers/index";
import { IMapOptions } from "../interfaces/mapoptions";

const GoogleMapStatic = () => {
    const mapoptions = useAppSelector<IMapOptions>((x: RootState) => x.mapoptions);

    return (<div className='staticmap'>
        <div className="map">
            <a className='btn btn-primary' rel="nofollow" href={mapoptions.halfway.dynamicUrl}>Load Map</a>
        </div>
    </div>);
};

export default GoogleMapStatic;
